import './styles/Form.scss';

import { HTMLAttributes, PropsWithChildren } from 'react';

import { useClassHelper } from '../../hooks';

interface Props extends HTMLAttributes<HTMLFormElement>, PropsWithChildren {
  loading?: boolean;
  formClassName?: string;
}

const componentName = 'c-CustomForm';

export const Form = ({
  loading,
  children,
  className,
  formClassName,
  ...rest
}: Props) => {
  const c = useClassHelper(componentName);
  const customC = useClassHelper('');

  return (
    <form {...rest} className={`${c('base')} ${customC(formClassName)}`}>
      <fieldset
        disabled={Boolean(loading)}
        aria-busy={Boolean(loading)}
        className={`${c('__fieldset')} ${className}`}
      >
        {children}
      </fieldset>
    </form>
  );
};
